var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-12 offset-md-4"},[_c('GiveInput')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }